var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.3 29.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #cccccb;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Support"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.69,2.99v7.01h-5.26c-1.34,0-2.43,1.09-2.43,2.43v.52l-5.26,3.55v-3.69h-1.75c-1.1,0-1.99-.89-1.99-2V2.99c0-1.1.89-1.99,1.99-1.99h12.7c1.1,0,2,.89,2,1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.88,10h-15.45c-1.34,0-2.43,1.09-2.43,2.43v9.51c0,1.35,1.09,2.43,2.43,2.43h6.68l6.64,4.49.02-4.49h2.11c1.34,0,2.42-1.08,2.42-2.43v-9.51c0-1.34-1.08-2.43-2.42-2.43ZM15.45,17.37s-.09-.04-.09-.09.04-.09.09-.09.09.04.09.09-.04.09-.09.09ZM20.05,17.37s-.09-.04-.09-.09.04-.09.09-.09.09.04.09.09-.04.09-.09.09ZM24.65,17.37s-.09-.04-.09-.09.04-.09.09-.09c.06,0,.1.04.1.09s-.04.09-.1.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_3_dots",
    "data-name": "3 dots"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.54,17.28s-.04.09-.09.09-.09-.04-.09-.09.04-.09.09-.09.09.04.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.14,17.28s-.04.09-.09.09-.09-.04-.09-.09.04-.09.09-.09.09.04.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.75,17.28s-.04.09-.1.09c-.05,0-.09-.04-.09-.09s.04-.09.09-.09c.06,0,.1.04.1.09Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.b9c912d1df56542c417aa9c9f56580a3.svg";
export { ForwardRef as ReactComponent };